const { ResourceGroup } = require("./resourceGroup.js");
const { isAssignPossible } = require("./../automation/automator.js");

class ResourcePool {
    constructor(simulator) {
        this.simulator = simulator;

        this.createInitialResources();
    }

    createInitialResources() {
        this.resourceGroups = [];
        this.resourceGroupsNameDict = {};
        this.resourceGroupsIDDict = {};
        const resourceParams = this.simulator.params.resourceParams;

        resourceParams.forEach((currResourceParams, index) => {
            const startAmount = this.simulator.params.startResourcesAmounts[index]
            var resourceGroup = new ResourceGroup(this.simulator, currResourceParams, startAmount)
            this.resourceGroups.push(resourceGroup)
            this.resourceGroupsNameDict[resourceGroup.name] = resourceGroup;
            this.resourceGroupsIDDict[resourceGroup.id] = resourceGroup;
        })
    }

    getAllResources() {
        var returnArray = [];
        this.resourceGroups.forEach(currGroup => {
            currGroup.resources.forEach(currResource => {
                returnArray.push(currResource);
            })
        })

        return returnArray;
    }

    getResourceGroupFromName(name){
        return this.resourceGroupsNameDict[name];
    }

    getResourceGroupFromID(id){
        return this.resourceGroupsIDDict[id];
    }

    updateHours() {
        this.resourceGroups.forEach(currGroup => {
            currGroup.updateHours();
        })
    }

    //If not all resources are working, don't simulate
    notAllResourcesAssigned(state) {

        var readyTasks = this.simulator.projectPool.getAllReadyTasks();
        var possibleResourceNotAssigned = false
        this.getAllResources().forEach(currResource => {
            readyTasks.forEach(currTask => {
                possibleResourceNotAssigned |= isAssignPossible(currResource, currTask, true, false);
            })
        });

        return possibleResourceNotAssigned;
    }

    getCurrentCapacities(){
        var capacities = {B: 0, O: 0, I: 0, M: 0, A: 0, P: 0};
        this.resourceGroups.forEach(currGroup => {
            var id = currGroup.id;
            var total = 0;

            currGroup.resources.forEach(currResource => {
                total += currResource.isActive ? 1 : 0;
            })
            
            if(currGroup.alternateName == null){
                capacities[id] += total;
            }

            else{
                var alternateID = this.getResourceGroupFromName(currGroup.alternateName);
                capacities[id] += total / 2;
                capacities[alternateID.id] += total / 2;

            }
        })

        return capacities;
    }
}


module.exports = { ResourcePool };
